module.exports = __webpack_public_path__ + "media/customizations/trailselizabethcreek/logo-e763b688965d839db2a97031da6ec732.png";